import {
    SYNC_UPDATE_NEWS_HASH,
    SYNC_UPDATE_ADS_TIMESTAMP,
    SYNC_UPDATE_TWITCH_STATUS,
    SYNC_UPDATE_BACKGROUND,
    SYNC_UPDATE_VERSIONS,
    SYNC_UPDATE_HASH,
} from '../constants'

// Initial state of the store
const initialState = {
    hash: undefined, // string
    ads: undefined, // timestamp
    news: undefined, // timestamp
    twitch: {
        streaming: false,
        name: '',
        url: '',
    },
    versions: {
        dev: undefined,
        release: undefined,
    },
}

// Commands for the state machine
const sync = (state = initialState, action) => {
    switch (action.type) {
        case SYNC_UPDATE_HASH:
            return {
                ...state,
                twitch: { ...state.twitch },
                versions: { ...state.versions },
                hash: action.payload,
            }

        case SYNC_UPDATE_ADS_TIMESTAMP:
            return {
                ...state,
                twitch: { ...state.twitch },
                versions: { ...state.versions },
                ads: action.payload,
            }

        case SYNC_UPDATE_BACKGROUND:
            return {
                ...state,
                twitch: { ...state.twitch },
                versions: { ...state.versions },
                background: action.payload.background,
            }

        case SYNC_UPDATE_NEWS_HASH:
            return {
                ...state,
                twitch: { ...state.twitch },
                versions: { ...state.versions },
                news: action.payload,
            }

        case SYNC_UPDATE_TWITCH_STATUS:
            return {
                ...state,
                versions: { ...state.versions },
                twitch: action.payload,
            }

        case SYNC_UPDATE_VERSIONS:
            return {
                ...state,
                twitch: { ...state.twitch },
                versions: action.payload,
            }

        // Default state
        default:
            return state
    }
}

export default sync



// WEBPACK FOOTER //
// ./src/reducers/sync.js